import React from 'react';
import './PaymentDetails.scss';
import { SiAlipay } from "react-icons/si";
import paymentData from './paymentData.json'; // Update the path as necessary

const PaymentDetails = () => {
  return (
    <div className="payment-details">
      <div className="line">
        <span className="label">Transaction ID:</span>
        <span className="value">{paymentData.transaction_id}</span>
      </div>
      <hr />
      <div className="line">
        <span className="label">Currency:</span>
        <span className="value">{paymentData.currency}</span>
      </div>
      <hr />
      <div className="line">
        <span className="label">Payment Method:</span>
        <span className="value payment-method"><SiAlipay className='si'/>  {paymentData.payment_method}</span>
      </div>
      <hr />
      <div className="line">
        <span className="label">Amount Paid:</span>
        <span className="value">{paymentData.amount_paid}</span>
      </div>
      <hr />
      <div className="line">
        <span className="label">Balance Due:</span>
        <span className="value">{paymentData.balance_due}</span>
      </div>
      <hr />
      <div className="line">
        <span className="label">Payment Time:</span>
        <span className="value">{paymentData.payment_time}</span>
      </div>
    </div>
  );
};

export default PaymentDetails;
